/**
 * Ksting
 *
 * Copyright © 2020 Rana Terning. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { string, func, object } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { getJob as getJobAction } from 'actions/job';

import SpinnerIcon from 'components/SpinnerIcon/SpinnerIcon';
import JobCard from './JobCard/JobCard';
import Title from 'components/Title/Title';
import Button from 'components/Button/Button';

import styles from './job-view.scss';
import { createUrl } from 'utils/urlHelper';
import classNames from 'clsx';

/**
 * This is the ViewJob component.
 *
 * @author Rana Terning <rana.terning@vntrs.com>
 * @author Niklas Rosdahl <niklas.rosdahl@vntrs.com>
 */

export class JobView extends Component {
  componentDidMount() {
    const {
      auth: { token },
      match: { params },
      getJob,
      job,
    } = this.props;

    const loadJob = job.job_id !== params.jobId;

    if (loadJob) {
      getJob(token, params.jobId);
    }
  }

  /**
   * Render JobView.
   *
   * @return {Object}
   */
  render() {
    const {
      job: {
        loading,
        title,
        date_starts,
        date_ends,
        location,
        job_id,
        favorites,
        team_discussion_id,
      },
      history,
    } = this.props;

    if (loading) {
      return (
        <section className={styles.wrapper}>
          <div className={styles.spinner}>
            <SpinnerIcon medium />
          </div>
        </section>
      );
    }

    return (
      <section className={styles.wrapper}>
        <header className={styles.header}>
          <Title title="Project" />
          <Button className={styles.cta} path={createUrl('jobs')}>
            ALL PROJECTS
          </Button>
        </header>

        <div className={styles.container}>
          <h2 className={styles.title}>{title}</h2>
          <JobCard
            job={{
              title,
              date_starts,
              date_ends,
              location,
              job_id,
              team_discussion_id,
            }}
          />
        </div>

        <div className={styles.talentWrapper}>
          <div className={classNames(styles.header, styles.talentHeader)}>
            <h2 className={styles.title}>Talents</h2>
            <Button className={styles.talentsButton} path={`/talents`}>
              BROWSE TALENTS
            </Button>
          </div>

          <div className={styles.talentContainer}>
            {favorites.map(({ talents }) =>
              talents.map(talent => (
                <div key={talent.talent_id}>
                  <div
                    className={styles.talent}
                    onClick={() =>
                      history.push(createUrl('profile', talent.talent_id))
                    }
                  >
                    <div
                      className={styles.talentImage}
                      style={{
                        backgroundImage: `url(${talent.picture.square_url})`,
                      }}
                    />
                    <div className={styles.talentText}>
                      <span className={styles.talentRole}>
                        {talent.role_name}
                      </span>
                      <span className={styles.talentName}>
                        {talent.fullname}
                      </span>
                    </div>
                  </div>
                  <Button
                    dark
                    ghost
                    path={createUrl('message', talent.discussion_id)}
                    className={styles.chatButton}
                  >
                    open messages
                  </Button>
                </div>
              ))
            )}
          </div>
        </div>
      </section>
    );
  }
}

/**
 * Declare expected property types.
 *
 * @type {Object}
 */
JobView.propTypes = {
  title: string.isRequired,
  auth: object.isRequired,
  getJob: func.isRequired,
  job: object.isRequired,
  history: object.isRequired,
};

/**
 * Set default properties.
 *
 * @type {Object}
 */
JobView.defaultProps = {
  title: '',
  job: {},
};

export default withRouter(
  connect(({ auth, bootstrap, job }) => ({ auth, bootstrap, job }), {
    getJob: getJobAction,
  })(JobView)
);
